import Core from "./core";
import Shell from "./shell";
import Particles from "./particles";
import Shine from "./shine";
import getPersistentUrl from "../../utils/persistent-path";
import RenderManager from "../../rendering/render-manager";

const axis = new THREE.Vector3(0, 1, 0);

class Star extends THREE.Group {
    constructor() {
        super();

        const textureLoader = new THREE.TextureLoader();
        const coreColormap = textureLoader.load(getPersistentUrl("star/core.png"));
        const coreNormalmap = textureLoader.load(getPersistentUrl("star/core_normal.png"));
        const shineColormap = textureLoader.load(getPersistentUrl("star/sunshine.png"));

        this._clock = new THREE.Clock(true);

        this.name = "Star";
        this.type = "Star";
        this.isStar = true;
        this.isUpdatable = true;
        this.isUniformScale = true;

        this._temperature = 2000;

        this._inner = new THREE.Group();
        this._outer = new THREE.Group();

        this._core = new Core({ star: this, temperature: this._temperature, map: coreColormap, normalMap: coreNormalmap });
        this._shell = new Shell({ star: this, temperature: this._temperature, map: coreColormap, normalMap: coreNormalmap });

        this._particles = new Particles({ star: this, temperature: this._temperature });
        this._shine = new Shine({ star: this, temperature: this._temperature, map: shineColormap });

        this._inner.add(this._core).add(this._shell);
        this._outer.add(this._particles).add(this._shine);

        this._root = new THREE.Group();

        this._root.add(this._inner).add(this._outer);

        this._root.scale.divideScalar(6);

        this.add(this._root);
    }

    get temperature() { return this._temperature; }
    set temperature(temp) {
        this._temperature = temp;
        this._core.material.uniforms.temperature.value = temp;
        this._shell.material.uniforms.temperature.value = temp;
        this._particles.material.uniforms.temperature.value = temp;
        this._shine.material.uniforms.temperature.value = temp;
    }

    get core() { return this._core; }

    update() {
        const time = this._clock.getElapsedTime();

        this._inner.quaternion.setFromAxisAngle(axis, THREE.Math.DEG2RAD * time);

        this._core.update(time);
        this._shell.update(time);
        this._particles.update(time);
        this._shine.update(time);

        RenderManager.containsAnimatedObjects = true;
    }
}

export default Star;
export { Star };